module.exports = __webpack_public_path__ + "static/img/gaozhonghuaxue4.18ac2094.jpg";